import { connect } from 'react-redux';
import { actionCreators } from 'dux/clickTracker';
// eslint-disable-next-line import/no-named-as-default
import SegmentClickTracker from './SegmentClickTracker';

const mapDispatchToProps = {
  trackButtonClick: actionCreators.trackButtonClick,
};

export default connect(null, mapDispatchToProps)(SegmentClickTracker);
